import {AuthorizationBillItem, AuthorizationInfo} from "../domain";
import {intersection, isEmpty} from "lodash";

export function isSelectingBilledMonths(authItems: AuthorizationBillItem[], auth: AuthorizationInfo): boolean {
    const selectedMonths = authItems
        .map((item) => {
            const dt = item.startDate;

            if (isEmpty(dt)) {
                return null;
            }

            const test = Date.parse(dt);
            if (isNaN(test)) {
                return null;
            }

            return dt.split('-').slice(0, 2).join('-');
        })
        .filter((dt) => dt !== null);

    const billedMonths = auth.billedMonths || [];

    return intersection(selectedMonths, billedMonths).length > 0;
}

export function getErrMsgForSelectingActiveClient(authorization: AuthorizationInfo) {
    const pluralized = authorization.billedMonths.length > 1 ? 'these months' : 'this month';
    return `Unable to submit risk reasons: we billed the client in ${authorization.billedMonths}, the client is active in ${pluralized}`;
}
